<template>
  <div>
    <el-popover
        placement="bottom"
        title="エラー"
        width="500"
        trigger="click"
        @created="handlePopupCreated"
        v-show="mode === 'error'">
      <connector-error-panel :errors="errors" :has-links="hasLinks"></connector-error-panel>
      <v-icon color="red" class="clickable" slot="reference">mdi-alert-circle</v-icon>
    </el-popover>

    <el-popover
        placement="bottom"
        title="警告"
        width="500"
        trigger="click"
        @created="handlePopupCreated"
        v-show="mode === 'warn'">
      <connector-error-panel :errors="errors" :has-links="hasLinks"></connector-error-panel>
      <v-icon color="orange" class="clickable" slot="reference">mdi-alert</v-icon>
    </el-popover>

    <el-popover
        placement="bottom"
        title="情報"
        width="500"
        trigger="click"
        @created="handlePopupCreated"
        v-show="mode === 'info'">
      <connector-error-panel :errors="errors" :has-links="hasLinks"></connector-error-panel>
      <readonly-checkbox :value="hasLinks" class="clickable" slot="reference"></readonly-checkbox>
    </el-popover>
  </div>
</template>

<script>
import ConnectorErrorPanel from "@/components/pages/contract/TradeContract/AdaptContract/ConnectorErrorPanel.vue";
import ReadonlyCheckbox from "@/components/atoms/ReadonlyCheckbox.vue";
export default {
  name: "ConnectorErrorIndicator",
  components: {ReadonlyCheckbox, ConnectorErrorPanel},
  props: {
    connector: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      popovers: []
    };
  },
  beforeDestroy() {
    for(const popover of this.popovers) {
      popover.doClose();
      popover.doDestroy();
    }
  },
  computed: {
    errors() {
      return this.connector.errors();
    },
    hasLinks() {
      return !!this.connector.links.length;
    },
    mode() {
      if(this.errors.hasError) {
        return 'error';
      } else if(this.errors.hasWarn) {
        return 'warn';
      } else {
        return 'info';
      }
    },
  },
  methods: {
    handlePopupCreated(popover) {
      document.querySelector('#app').appendChild(popover.popperElm);
      this.popovers.push(popover);
    }
  }
}
</script>

<style scoped>
.clickable {
  cursor: pointer;
}

.clickable:focus {
  outline: none;
}
</style>
